var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgArrow = function SvgArrow(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2678 15C11.0376 16.3333 11.4225 17 11.9999 17C12.5772 17 12.9621 16.3333 13.7319 15L15.464 12C16.2338 10.6667 16.6187 10 16.33 9.5C16.0413 9 15.2715 9 13.7319 9H10.2678C8.72821 9 7.95841 9 7.66974 9.5C7.38106 10 7.76596 10.6667 8.53576 12L10.2678 15Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgArrow);
export { ForwardRef as ReactComponent };